import {FileObject} from 'api/library';
import {Folder, ID, PreviewObject} from 'types';

export type TextValue = string;
export type ImageValue = (FileObject['id'] | undefined)[];
export type VideoValue = FileObject['id'];
export type DocumentValue = FileObject['id'];
export type GalleryValue = FileObject['id'][];

export type ContentValue =
  | TextValue
  | ImageValue
  | VideoValue
  | DocumentValue
  | GalleryValue;

export enum ContentType {
  Text = 'text',
  Image = 'image',
  Video = 'video',
  Document = 'document',
  Gallery = 'gallery',
}

export interface ContentObject {
  id: ID;
  value: ContentValue | undefined;
  contentType: ContentType;
}

export interface LessonObject {
  id: ID;
  date?: Date;
  title: string;
  description: string;
  time: number;
  preview?: PreviewObject;
  userID?: ID;
  content: ContentObject[];
  tags?: string[];
  folders?: Folder[];
}
